/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes, { object } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';

import DesktopAccountBillingInfo from './DesktopAccountBillingInfo';
import configENV from '../../../../config';
import { isEmpty } from '../../../../utils/object';
import { getFeatureFlags } from '../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const { PERSIST_KEY } = configENV;

class DesktopBillingAddress extends React.Component {
    componentDidMount = () => {
        const { billingAddress, wallet, fetchBillingAddress } = this.props;
        fetchBillingAddress(billingAddress, wallet);
    };

    render() {
        const {
            billingAddress,
            countries,
            wallet,
            featureFlags,
        } = this.props;
        const {
            handleClickEditBillingAddress,
        } = this.props;
        const defaultCreditCard = wallet.filter((w) => w.subsIndicator === '1');
        const isAddressBookEnabled = featureFlags['is-address-book-service-enabled'];

        return (
            <>
                <>
                    {isAddressBookEnabled
                    && (
                        <DesktopAccountBillingInfo
                            billingAddress={billingAddress}
                            countries={countries}
                            wallet={!isEmpty(defaultCreditCard) ? defaultCreditCard : wallet}
                            onEdit={handleClickEditBillingAddress}
                        />
                    )}
                </>
            </>
        );
    }
}

DesktopBillingAddress.defaultProps = {
    billingAddress: [],
    wallet: [],
    countries: [],
    // cardtypes: [],
};

DesktopBillingAddress.propTypes = {
    billingAddress: PropTypes.array,
    wallet: PropTypes.array,
    countries: PropTypes.array,
    fetchBillingAddress: PropTypes.func.isRequired,
    handleClickEditBillingAddress: PropTypes.func.isRequired,
    featureFlags: object.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isFetchingModal: newState.isFetchingModal,
        toggleState: newState.toggleState,
        billingAddress: newState.billingAddress,
        wallet: newState.wallet,
        countries: newState.countries,
        cardtypes: newState.cardtypes,
        featureFlags: getFeatureFlags(state),
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchBillingAddress: (billingAddress, wallet) => dispatch(EventDispatcher.fetchBillingAddress(billingAddress, wallet)),
    handleClickEditBillingAddress: (address, wallet, template) => dispatch(EventDispatcher.handleClickEditBillingAddress(address, wallet, template)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(DesktopBillingAddress));
